import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[preventE]'
})
export class PreventEDirective {

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'e') {
      event.preventDefault();
    }
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/prevent-e.directive.ts